import React, { ClipboardEvent, useState } from 'react';
import FormTextField from '../../../../ui/forms/fields/text-field';
import {
    createControl,
    removeInvisibleCharsOnPaste,
    updateControl,
    validateControl, validateForm
} from '../../../../domain/validation/validation';
import FormTextAreaField from '../../../../ui/forms/fields/textarea-field';
import { getHiddenDataString } from '../../../../domain/hidden-data-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../dal/store';
import Preloader from '../../../../ui/svg/common/preloader';
import { sendEmail } from '../dal/data-service';
import { DEFAULT_ERROR } from '../../../../DAL/data-provider';

const EmailForm = () => {

    const dispatch = useAppDispatch();

    const [ loading, setLoading] = useState(false);
    const [ showOkMessage, setShowOkMessage ] = useState(false);
    const [ showErrorMessage, setShowErrorMessage ] = useState(false);

    const userWidget = useAppSelector(store => store.root.userWidget);

    const [fromEmailControl, setFromEmailControl] = useState(createControl('fromEmail', getHiddenDataString('waves-user-email'), {
        required: true,
        email: true,
    }));

    const [toEmailControl, setToEmailControl] = useState(createControl('toEmail', '', {
        required: true,
        email: true,
    }));

    const [messageControl, setMessageControl] = useState(createControl('message', '', {

    }));

    const onCancelClick = () => {
        dispatch(
            rootActions.main({
                emailFormVisible: false,
            })
        );
    };

    const onSendClick = async () => {

        if(!userWidget) return;

        setShowOkMessage(false);
        setShowErrorMessage(false);

        const isValid = validateForm([
            [fromEmailControl, setFromEmailControl],
            [toEmailControl, setToEmailControl],
            [messageControl, setMessageControl],
        ]);
        if(!isValid) return;

        setLoading(true);

        const emailResult = await sendEmail(
            userWidget.widgetID,
            userWidget.shortURL,
            fromEmailControl.value,
            toEmailControl.value,
            messageControl.value
        );

        setLoading(false);

        if(emailResult.data.isValid) {
            setShowOkMessage(true);

            window.setTimeout(() => {
                dispatch(
                    rootActions.main({
                        emailFormVisible: false,
                    })
                );
            }, 3000);
        }
        else{
            setShowErrorMessage(true);
        }
    };

    return (
      <div className="mb-4 mx-auto max-w-full text-left" style={{
          width: '500px',
      }}>
          <FormTextField
              id={ 'fromEmail' }
              label={ 'From' }
              control={ fromEmailControl }
              maxLength={ 80 }
              disabled={ true }
              textBoxClasses="rounded bg-gray-100"
          />

          <FormTextField
              id={ 'toEmail' }
              label={ 'To' }
              control={ toEmailControl }
              maxLength={ 80 }
              textBoxClasses="rounded"
              onChange={ evt => {
                  setToEmailControl(updateControl(toEmailControl, (evt.target as HTMLInputElement).value, !toEmailControl.isValid));
              }}
              onBlur={ () => {
                  setToEmailControl(validateControl(toEmailControl));
              }}
              onKeyUp={ evt => {
                  setToEmailControl(updateControl(toEmailControl, (evt.target as HTMLInputElement).value, !toEmailControl.isValid));
              }}
              onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                  setToEmailControl(updateControl(toEmailControl, removeInvisibleCharsOnPaste(evt), !toEmailControl.isValid));
              }}
          />

          <FormTextAreaField
              id={ 'message' }
              label={ 'Message'}
              control={ messageControl }
              cols={ 4 }
              rows={ 5 }
              onChange={ evt => {
                  setMessageControl(updateControl(messageControl, (evt.target as HTMLInputElement).value, !messageControl.isValid));
              }}
              onBlur={ () => {
                  setMessageControl(validateControl(messageControl));
              }}
              onKeyUp={ (evt) => {
                  setMessageControl(updateControl(messageControl, (evt.target as HTMLInputElement).value, !messageControl.isValid));
              } }
              onPaste={ (evt: ClipboardEvent<HTMLInputElement>) => {
                  setMessageControl(updateControl(messageControl, removeInvisibleCharsOnPaste(evt), !messageControl.isValid));
              }}
          />

          <div className="flex items-center justify-center">
              { loading && <Preloader width="25px" height="25px" color="#4f4f4f" /> }
              {
                  !loading &&
                  (
                      <>
                          <button type="button" className="w-btn w-auto mr-1 border-blue-200 px-10" onClick={ onSendClick }>Send</button>
                          <button type="button" className="w-btn w-auto ml-1 w-btn-outline-black px-8" onClick={ onCancelClick }>Cancel</button>
                      </>
                  )
              }
          </div>

          {
              showOkMessage &&
              <div className="ok-box mt-4 text-sm"  role="alert">Email sent successfully</div>
          }

          {
              showErrorMessage &&
              <div className="error-box mt-4 text-sm"  role="alert">{ DEFAULT_ERROR }</div>
          }
      </div>
    )
};

export default EmailForm;